<script lang="ts">
    import pkg from '../../../package.json';
</script>

<section class="appInfo">
    <h5>{pkg.name}</h5>
    <small>{pkg.displayVersion}</small>
</section>

<style lang="scss">
    .appInfo {
        position: fixed;
        bottom: .5rem;
        left: .5rem;
        display: flex;
        flex-direction: column;
        color: white;

        h5 {
            font-size: .5rem;
        }

        small {
            display: block;
            font-size: .75rem;
        }
    }
</style>